<template>
    <div>
        <preloader :display="loading" size="small"/>
        <el-checkbox
            v-model="checkboxValue"
            @change="updateSelected()"
            :class="'mt-2'" />  
    </div>
</template>

<script>
    import Preloader from "vcomponents/utilities/Preloader.vue";
    export default {
        props: {
            initialCheckboxValue: {
                type : Boolean,
                required : true
            },
            route: {
                type: String,
                required: true
            },
            routeParam: {
                type: String,
                required: false
            },
        },
        data : function(){
            return {
                loading: false,
                checkboxValue: false,
            }
        },
        created(){
            this.checkboxValue = this.initialCheckboxValue
        },
        methods: {
            updateSelected() {
                const newValue = this.checkboxValue
                this.loading = true
                this.$ajax.put(this.route, {},
                    {
                        "value" : newValue,
                        "field" : this.routeParam,
                    },
                    (response) => {
                        this.loading = false
                    },
                    (error) => {
                        this.checkboxValue = !this.checkboxValue
                        this.loading = false
                        Push.error(error)
                    }
                )
            }
        },

        components: {
            Preloader,
        }
    }
</script>
